import { useCallback, useEffect, useRef, useState } from 'react';

import {
	Box,
	Heading,
	Table,
	TableContainer,
	Tbody,
	Text,
	Th,
	Thead,
	Tr,
} from '@chakra-ui/react';

import { getAllPedidos } from '../../services/pedidos';
import PedidoTableItem from '../../components/Pedidos/PedidoTableItem';
import Layout from '../../components/Layout/Layout';
import FiltroPedidos from '../../components/Filtros/FiltroPedidos';

const ListarPedidos = () => {
	const [pedidos, setPedidos] = useState([]);
	// const [pedidosFiltrados, setPedidosFiltrados] = useState(pedidos);
	// const [needReload, setNeedReload] = useState(true);

	const [page, setPage] = useState(1);
	const [loading, setLoading] = useState(false);
	const [hasMore, setHasMore] = useState(true);
	const [filtros, setFiltros] = useState({});

	const loaderRef = useRef(null);

	const loadMorePedidos = useCallback(
		async (pagina, filtrosABuscar) => {
			if (loading || !hasMore) return;
			setLoading(true);
			try {
				const nuevosPedidos = await getAllPedidos(
					pagina,
					25,
					filtrosABuscar,
				);
				if (nuevosPedidos.length < 10) setHasMore(false);

				setPedidos(prevPedidos => [...prevPedidos, ...nuevosPedidos]);
				setPage(prevPage => prevPage + 1);
			} catch (error) {
				console.error('Error al cargar más pedidos:', error);
				setHasMore(false);
			} finally {
				setLoading(false);
			}
		},
		[hasMore, loading],
	);

	const handleFiltros = ({ target }) => {
		const { value } = target;

		const newFilters = {
			...filtros,
			[target.name]: value,
		};

		setFiltros(newFilters);
		setPedidos([]);
		setPage(1);
		setHasMore(true);
		loadMorePedidos(1, newFilters);
	};

	useEffect(() => {
		const observer = new IntersectionObserver(
			entries => {
				entries.forEach(entry => {
					if (entry.isIntersecting) {
						loadMorePedidos(page, filtros);
					}
				});
			},
			{ threshold: 1.0 },
		);

		if (loaderRef.current) {
			observer.observe(loaderRef.current);
		}

		return () => {
			if (loaderRef.current) {
				// eslint-disable-next-line react-hooks/exhaustive-deps
				observer.unobserve(loaderRef.current);
			}
		};
	}, [loadMorePedidos, page, filtros, loading, hasMore]);

	// useEffect(() => {
	// 	const getPedidos = async () => {
	// 		const auxPedidos = await getAllPedidos();
	// 		setPedidos(auxPedidos);
	// 		setNeedReload(false);
	// 	};

	// 	needReload && getPedidos();
	// }, [needReload]);

	return (
		<Layout>
			<Box mb={4}>
				<Heading textAlign='center' color='blue.800'>
					PEDIDOS
				</Heading>
			</Box>

			<FiltroPedidos setFiltros={handleFiltros} />

			<Box mt={6}>
				<TableContainer
					w='100%'
					border='1px'
					borderColor='blue.400'
					rounded='lg'
					shadow='dark-lg'
					overflowX='auto'
					overflowY='auto'
				>
					<Table
						variant='simple'
						whiteSpace='nowrap'
						size={{ base: 'sm', md: 'md', lg: 'lg' }}
					>
						<Thead bgColor='blue.100'>
							<Tr>
								<Th>Nombre</Th>
								<Th>Estado</Th>
								<Th>Motivo</Th>
								<Th>Tipologia Inmueble</Th>
								<Th>Precio</Th>
								<Th>Fecha de creación</Th>
								<Th>Fecha de modificación</Th>
							</Tr>
						</Thead>
						<Tbody>
							{pedidos &&
								pedidos.map(pedido => {
									return (
										<PedidoTableItem
											key={pedido.uuid}
											pedido={pedido}
										/>
									);
								})}
						</Tbody>
					</Table>
				</TableContainer>
				<Box ref={loaderRef} height='40px' />
				{loading && (
					<Text textAlign='center' mt={4}>
						Cargando...
					</Text>
				)}
				{!hasMore && (
					<Text textAlign='center' mt={4}>
						No hay más pedidos para mostrar.
					</Text>
				)}
			</Box>
		</Layout>
	);
};

export default ListarPedidos;
